import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { tipCategories } from "@/mocks/siteData";

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <Reveal>
            <SectionHeading
              eyebrow="热门线索类型"
              title="这些领域，投稿最多"
              desc="如果你手里的线索属于以下方向，说明它已经有较高的关注度，也更容易找到可以交叉核实的公开信息。"
            />
          </Reveal>
          <Reveal delay={80}>
            <Link
              to="/channels"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-700 font-medium hover:bg-primary-100 transition-colors whitespace-nowrap cursor-pointer shrink-0"
            >
              我要投稿
              <i className="ri-arrow-right-line"></i>
            </Link>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {tipCategories.map((category, index) => (
            <Reveal key={category.id} delay={index * 40}>
              <Link
                to={`/channels#tips`}
                className="group flex flex-col items-start h-full p-5 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 text-xl group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                  <i className={category.icon}></i>
                </span>
                <span className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {category.name}
                </span>
                <span className="mt-1.5 text-xs text-foreground-500">
                  {category.count} 条相关线索
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}